export default "__VITE_ASSET__722acefa__"